import { TextInput } from '@core/components/Inputs';
import { Button, Grid, Typography } from '@material-ui/core';
import { useKeycloak } from '@react-keycloak/web';
import { link } from 'app/utils/coresUtil';
import { CLIENTS_ID, getClientId, getReCaptcha } from 'app/utils/enviromentUtil';
import { logoFM, logoGF } from 'app/utils/imagensUtil';
import { useFormikContext } from 'formik';
import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { Link } from 'react-router-dom';
import LayoutLogin from '../../publico/login/components/LayoutLogin';
import { recuperarSenhaStyles } from './styles/Styles';

const RecuperarSenha = () => {
  const { keycloak } = useKeycloak();
  const formikContext = useFormikContext();
  const { values, handleChange, handleBlur, errors, touched, submitCount, handleSubmit } = formikContext;

  const logo = getClientId() === CLIENTS_ID.financeiroFront ? logoFM : logoGF;
  const reCaptcha = getReCaptcha();
  const CLIENT_ID = getClientId();

  const styles = recuperarSenhaStyles();

  const _erros = {
    email: (submitCount > 0 || touched?.email) && errors?.email,
  };

  const handleChangeCaptcha = (captcha) => {
    formikContext.setFieldValue('reCaptcha', captcha);
  };

  return (
    <LayoutLogin
      logoImg={<img src={logo} className={styles.logoImg} alt="logo" />}
      logoTitulo={
        <Typography className={styles.logoTitulo}>
          Bem-vindo ao <br />
          {CLIENT_ID === CLIENTS_ID.financeiroFront ? 'FatureMais' : 'Group Financeiro'}
        </Typography>
      }
      cardContent={
        <>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography className={styles.cardTitulo}>Recupere sua senha</Typography>
            </Grid>

            <Grid item xs={12}>
              <TextInput
                id="email"
                label="Email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.email}
                touched={!!_erros.email}
                error={_erros.email}
                required
                maxLength={100}
              />
            </Grid>

            <Grid item xs={12}>
              <ReCAPTCHA sitekey={reCaptcha} hl="pt-br" onChange={handleChangeCaptcha} />
            </Grid>

            <Grid item xs={12}>
              <Button variant="contained" className={styles.button} onClick={handleSubmit}>
                Enviar novo acesso
              </Button>
            </Grid>

            <Grid item xs={12}>
              <div className={styles.linkVoltar}>
                <Link to="/" style={{ color: link }} onClick={() => keycloak.login()}>
                  Voltar para o login
                </Link>
              </div>
            </Grid>
          </Grid>
        </>
      }
    />
  );
};

export default RecuperarSenha;
